var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _g, _path13, _path14, _circle, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _g2, _g3, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _g4, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHouse(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    role: "img",
    className: "iconify iconify--emojione",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#c94747",
    d: "M39 38l14.8 4.1H42.5L27 38z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9f3d9",
    d: "M5 22h22v38H5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#dbb471",
    d: "M27 22h12v16H27z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ed4c5c",
    d: "M21 8L1.1 22H27z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#d0d0d0",
    d: "M29 10h3v8h-3z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#94989b",
    d: "M32 10h2v9h-2z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#c94747",
    d: "M21 8l22 14H27z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#d0d0d0",
    d: "M28 8h5v2h-5z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#94989b",
    d: "M33 8h2v2h-2z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#d6eef0",
    d: "M12.8 27.8h6.4v6.4h-6.4z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12 27v8h8v-8h-8m7.2.8v2.8h-2.8v-2.8h2.8m-3.6 0v2.8h-2.8v-2.8h2.8m-2.8 6.4v-2.8h2.8v2.8h-2.8m3.6 0v-2.8h2.8v2.8h-2.8",
    fill: "#89664c"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#d6eef0",
    d: "M30.6 27.4h4.8v7.2h-4.8z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#89664c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.2 27v8h5.6v-8h-5.6m.8.8h1.6v2.8H31v-2.8m0 6.4v-2.8h1.6v2.8H31m4 0h-1.6v-2.8H35v2.8m0-3.6h-1.6v-2.8H35v2.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7 49.1h6.2V60h-6.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2 47.5h1.6v1.6h-1.6z"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#594640",
    d: "M12.1 49.1h1.6V60h-1.6z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#dbb471",
    d: "M11.4 47.5h7.8v1.6h-7.8z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.6,
    cy: 53.8,
    r: 0.6,
    fill: "#f9f3d9"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#83bf4f",
    d: "M.1 60h52v4H.1z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#dbb471",
    d: "M39.9 42.1h9.3V60h-9.3z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9f3d9",
    d: "M27 42.1h12.9V60H27z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#ed4c5c",
    d: "M27 38H5l-5 4.1h42.5z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#d6eef0",
    d: "M28.3 47.8h6.4v6.4h-6.4z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 47v8h8v-8h-8m7.2.8v2.8h-2.8v-2.8h2.8m-3.6 0v2.8h-2.8v-2.8h2.8m-2.8 6.4v-2.8h2.8v2.8h-2.8m3.6 0v-2.8h2.8v2.8h-2.8",
    fill: "#89664c"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#d6eef0",
    d: "M42.1 47.4h4.8v7.2h-4.8z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7 47v8h5.6v-8h-5.6m.8.8h1.6v2.8h-1.6v-2.8m0 6.4v-2.8h1.6v2.8h-1.6m4 0h-1.6v-2.8h1.6v2.8m0-3.6h-1.6v-2.8h1.6v2.8",
    fill: "#89664c"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#699635",
    d: "M51.9 60h12v4h-12z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#d3976e",
    d: "M52.2 34h4v26h-4z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2 34h-1.5v.5c0 2.3-.8 2.3-.8 4.6s.8 2.3.8 4.5c0 2.3-.8 2.3-.8 4.6s.8 2.3.8 4.5c0 2.3-.8 2.3-.8 4.5c0 1.4.2 2 .4 2.7h1.8c.1.1.1-25.9.1-25.9",
    fill: "#89664c"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2 2.9C51.3 5.6 49 .7 46 4.9s-1.4 7.9-.5 10.6c1.8 5.5-1.9 7.2.6 11.8c2.4 4.6-1.1 6.8 3.5 9.3s2.3-2.9 7 .3c4.7 3.2 5.3-2.2 4.8-4.2c-1-3.7 1.7-4.6 2.5-7.7c1.3-5.5-3.1-8.5-1.7-13.7c1.2-5.1-3.3-16.7-9-8.4",
    fill: "#83bf4f"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M62 11.4C63.1 7.5 60.8 0 57.2 0c0 0 2.4 3.2-1 7.2s2.9 6 0 9.7c-2.9 3.7 2.7 7.3.5 10.2c-2.7 3.6-7 3.1-4.5 10v.1c1-.6 1.1-2.3 4.2-.2c4.7 3.2 5.3-2.2 4.8-4.2c-1-3.7 1.7-4.6 2.5-7.7c1.4-5.5-3-8.5-1.7-13.7",
    fill: "#699635"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#83bf4f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.8 11.2c-.7 0 .4-.6.4-1.4s-1.1-1.4-.4-1.4c.7 0 1.4.6 1.4 1.4s-.6 1.4-1.4 1.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6 23.3c-1.1 0 .6-.9.6-2s-1.7-2-.6-2s2 .9 2 2s-.9 2-2 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8 33.5c-.8 0 0-.7 0-1.5s-.8-1.5 0-1.5s1.5.7 1.5 1.5s-.7 1.5-1.5 1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3 12.1c.8 0-.2.7-.2 1.5s1.1 1.5.2 1.5s-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.6 6.4c1.1 0-.5.9-.5 2s1.7 2 .5 2c-1.1 0-2-.9-2-2s.8-2 2-2"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#699635"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.7 21.6c1.7 0-.7 1.3-.7 3s2.3 3 .7 3c-1.7 0-3-1.3-3-3s1.3-3 3-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.6 16.1c.8 0 0 .7 0 1.5s.8 1.5 0 1.5s-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5"
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#83bf4f",
    d: "M58.1 57h.4v3h-.4z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2 53.9v2.3c0 .4.3.8.8.8h.8v-1.6c-.1-1.1-1.6-1.5-1.6-1.5",
    fill: "#c94747"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5 53.9v2.3c0 .4-.3.8-.8.8h-.8v-1.6c0-1.1 1.6-1.5 1.6-1.5",
    fill: "#ed4c5c"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#83bf4f",
    d: "M62.5 54.7h.4V60h-.4z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6 51.5v2.3c0 .4.3.8.8.8h.8V53c-.1-1-1.6-1.5-1.6-1.5",
    fill: "#c94747"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9 51.5v2.3c0 .4-.3.8-.8.8h-.8V53c0-1 1.6-1.5 1.6-1.5",
    fill: "#ed4c5c"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7 50.2v2.3c0 .4.3.8.8.8h.8v-1.6c0-1-1.6-1.5-1.6-1.5",
    fill: "#f2b200"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1 50.2v2.3c0 .4-.3.8-.8.8h-.8v-1.6c0-1 1.6-1.5 1.6-1.5",
    fill: "#ffce31"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#83bf4f",
    d: "M59.7 53.4h.4V60h-.4z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5 51.4v2.3c0 .4.4.8.8.8h.7V53c0-1.2-1.5-1.6-1.5-1.6",
    fill: "#f2b200"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8 51.4v2.3c0 .4-.3.8-.8.8h-.8V53c0-1.2 1.6-1.6 1.6-1.6",
    fill: "#ffce31"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#83bf4f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.4 54.5h.4V60h-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49 57h.4v3H49z"
  }))), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M48 53.9v2.3c0 .4.3.8.8.8h.8v-1.6c0-1.1-1.6-1.5-1.6-1.5",
    fill: "#c94747"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4 53.9v2.3c0 .4-.3.8-.8.8h-.8v-1.6c0-1.1 1.6-1.5 1.6-1.5",
    fill: "#ed4c5c"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#83bf4f",
    d: "M53.4 54.7h.4V60h-.4z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4 51.5v2.3c0 .4.3.8.8.8h.8V53c0-1-1.6-1.5-1.6-1.5",
    fill: "#c94747"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8 51.5v2.3c0 .4-.3.8-.8.8h-.8V53c0-1 1.6-1.5 1.6-1.5",
    fill: "#ed4c5c"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6 50.2v2.3c0 .4.3.8.8.8h.8v-1.6c0-1-1.6-1.5-1.6-1.5",
    fill: "#f2b200"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9 50.2v2.3c0 .4-.3.8-.8.8h-.8v-1.6c.1-1 1.6-1.5 1.6-1.5",
    fill: "#ffce31"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#83bf4f",
    d: "M50.6 53.4h.4V60h-.4z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3 51.4v2.3c0 .4.3.8.8.8h.8V53c0-1.2-1.6-1.6-1.6-1.6",
    fill: "#c94747"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7 51.4v2.3c0 .4-.3.8-.8.8h-.8V53c0-1.2 1.6-1.6 1.6-1.6",
    fill: "#ed4c5c"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#83bf4f",
    d: "M47.3 54.5h.4V60h-.4z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/house.80650a76b3e7d0fd8c9fdb03fdb1b273.svg";
export { ForwardRef as ReactComponent };